@use './variables' as *;
@use '../../styles/abstracts/break-points' as *;
@use '../../styles/abstracts' as *;

@mixin reset() {
  margin: 0;
  padding: 0;
}

:host {
  display: block;
}

.questionnaire {
  display: $questionnaire-display;
  font-family: $body-font-family;

  air-question {
    margin-bottom: $questionnaire-question-margin-bottom;
  }

  air-question-group {
    .question:last-child air-question {
      margin-bottom: $questionnaire-group-last-question-margin-bottom;
    }
    .section.depth-2 {
      border-left: $questionnaire-group-border-left;
      padding-left: $questionnaire-group-padding-left;
      margin-bottom: $questionnaire-group-margin-bottom;
    }
    air-question {
      --air-question-group-title-color: var(--air-group-headline-color);
      --air-question-group-title-font-family: var(--air-group-headline-font-family);
      --air-question-group-title-font-size: var(--air-group-headline-font-size);
      --air-question-group-title-font-weight: var(--air-group-headline-font-weight);
      --air-question-group-title-line-height: var(--air-group-headline-line-height);
      --air-question-group-title-margin-top: var(--air-spacing-05);
    }
  }

  .section {
    display: $questionnaire-section-display;
    grid-template-columns: $questionnaire-section-grid-template-columns;
  }

  .group {
    display: $questionnaire-group-display;
    grid-template-columns: $questionnaire-group-grid-template-columns;
  }

  .question {
    display: $questionnaire-question-display;
    position: $questionnaire-question-position;
    grid-template-columns: $questionnaire-question-grid-template-columns;
    gap: $questionnaire-question-grid-gap;

    .question-info {
      position: $questionnaire-question-info-position;
      width: $questionnaire-question-info-width;
      top: $questionnaire-question-info-top;
      left: $questionnaire-question-info-left;
      right: $questionnaire-question-info-right;
    }
  }

  .description {
    color: $questionnaire-description-color;
    font-family: $questionnaire-description-font-family;
    font-size: $questionnaire-description-font-size;
    font-weight: $questionnaire-description-font-weight;
    line-height: $questionnaire-description-line-height;
    margin-top: $questionnaire-description-margin-top;
    margin-bottom: $questionnaire-description-margin-bottom;
  }

  // root level section titles
  .depth-0 .title {
    display: $questionnaire-depth0-title-display;
    margin-top: $questionnaire-depth0-title-margin-top;
    margin-bottom: $questionnaire-depth0-title-margin-bottom;
    color: $questionnaire-depth0-title-color;
    font-weight: $questionnaire-depth0-title-font-weight;
    font-size: $questionnaire-depth0-title-font-size;
    line-height: $questionnaire-depth0-title-line-height;
    font-family: $questionnaire-depth0-title-font-family;
    text-decoration: $questionnaire-depth0-title-text-decoration;
    text-transform: $questionnaire-depth0-title-text-transform;
    p {
      @include reset();
    }
  }

  //groups and sections titles
  .depth-1 {
    air-divider {
      display: $questionnaire-depth1-divider-display;
      grid-template-columns: $questionnaire-question-grid-template-columns;
      margin-top: $questionnaire-depth1-divider-margin-top;
      margin-bottom: $questionnaire-depth1-divider-margin-bottom;
    }

    .title {
      display: $questionnaire-depth1-title-display;
      margin-top: $questionnaire-depth1-title-margin-top;
      margin-bottom: $questionnaire-depth1-title-margin-bottom;
      color: $questionnaire-depth1-title-color;
      font-weight: $questionnaire-depth1-title-font-weight;
      font-size: $questionnaire-depth1-title-font-size;
      line-height: $questionnaire-depth1-title-line-height;
      font-family: $questionnaire-depth1-title-font-family;
      text-decoration: $questionnaire-depth1-title-text-decoration;
      text-transform: $questionnaire-depth1-title-text-transform;
      p {
        @include reset();
      }
    }
  }

  // group titles, same style as question wording
  .depth-2 .title {
    display: $questionnaire-depth2-title-display;
    margin-top: $questionnaire-depth2-title-margin-top;
    margin-bottom: $questionnaire-depth2-title-margin-bottom;
    color: $questionnaire-depth2-title-color;
    font-weight: $questionnaire-depth2-title-font-weight;
    font-size: $questionnaire-depth2-title-font-size;
    line-height: $questionnaire-depth2-title-line-height;
    font-family: $questionnaire-depth2-title-font-family;
    text-decoration: $questionnaire-depth2-title-text-decoration;
    text-transform: $questionnaire-depth2-title-text-transform;
    display: $questionnaire-depth2-title-display;
    grid-template-columns: $questionnaire-depth2-title-template-columns;
    p {
      @include reset();
    }
  }
}

.message {
  display: $questionnaire-message-display;
  padding: $questionnaire-message-padding;
  margin: $questionnaire-message-margin;
  border: $questionnaire-message-border;
  color: $questionnaire-message-color;
  font-family: $questionnaire-message-font-family;
  font-size: $questionnaire-message-font-size;
  font-weight: $questionnaire-message-font-weight;
  line-height: $questionnaire-message-line-height;
  text-decoration: $questionnaire-message-text-decoration;
  text-transform: $questionnaire-message-text-transform;
}

@media (max-width: $breakpoint-mobile) {
  .questionnaire {
    .section {
      grid-template-columns: $mobile-questionnaire-question-grid-template-columns;
    }

    //groups and sections titles
    .depth-1 {
      air-divider {
        grid-template-columns: $mobile-questionnaire-question-grid-template-columns;
      }
    }
    .question {
      display: $mobile-questionnaire-question-display;
      grid-template-columns: $mobile-questionnaire-question-grid-template-columns;
      gap: $mobile-questionnaire-question-grid-gap;

      .question-info {
        position: $mobile-questionnaire-question-info-position;
        width: $mobile-questionnaire-question-info-width;
        left: $mobile-questionnaire-question-info-left;
      }
    }
    .depth-2 .title {
      display: $mobile-questionnaire-depth2-title-display;
      grid-template-columns: $mobile-questionnaire-depth2-title-template-columns;
    }
  }
}
